// src/EmbedChart.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Line } from 'react-chartjs-2';
import { useParams } from 'react-router-dom';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const EmbedChart = () => {
  const { id } = useParams();
  const [chartConfig, setChartConfig] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchChartConfig = async () => {
      try {
        const response = await axios.get(`/api/charts/${id}`);
        // On suppose que l'API renvoie un objet { chartConfig: { ... } }
        setChartConfig(response.data.chartConfig);
      } catch (err) {
        console.error(err);
        setError("Erreur lors du chargement du graphique.");
      }
    };
    fetchChartConfig();
  }, [id]);

  if (error) return <div className="alert alert-danger">{error}</div>;
  if (!chartConfig) return <div>Chargement...</div>;

  return (
    <div className="container mt-4">
      <h2>Graphique #{id}</h2>
      <Line data={chartConfig} />
    </div>
  );
};

export default EmbedChart;
